const initSlider = () => {
  const track = document.querySelector('.carousel__track');
  const slides = Array.from(track.children);
  const nextButton = document.querySelector('.carousel__button--right');
  const prevButton = document.querySelector('.carousel__button--left');
  let shouldAutoplay = true;
  let interval;

  const handleAutoplay = () => {
    if (shouldAutoplay) {
      interval = setInterval(function(){
        const currentSlide = track.querySelector('.current-slide');
        const nextSlide = currentSlide.nextElementSibling;
        const nextIndex = slides.findIndex(slide => slide === nextSlide);

        if (nextIndex < 0) {
          moveToSlide(track, currentSlide, slides[0]);
        } else {
          moveToSlide(track, currentSlide, currentSlide.nextElementSibling);
        }
      }, 5000);
    } else {
      clearInterval(interval);
    }
  };

  const setSlidePosition = (slide, index) => {
    const slideSize = slides[0].getBoundingClientRect();
    const slideWidth = slideSize.width;

    slide.style.left = slideWidth * index + 'px';
  };

  slides.forEach(setSlidePosition);

  window.addEventListener('resize', () => {
    slides.forEach(setSlidePosition);
  });

  const moveToSlide = (track, currentSlide, targetSlide) => {
    track.style.transform = 'translateX(-' + targetSlide.style.left + ')';
    currentSlide.classList.remove('current-slide');
    targetSlide.classList.add('current-slide');
  };

  prevButton.addEventListener(
    'click',
    e => {
      shouldAutoplay = false;
      handleAutoplay();
      const currentSlide = track.querySelector('.current-slide');
      const prevSlide = currentSlide.previousElementSibling;
      const prevIndex = slides.findIndex(slide => slide === prevSlide);

      if (prevIndex < 0) {
        moveToSlide(track, currentSlide, slides[slides.length - 1]);
      } else {
        moveToSlide(track, currentSlide, currentSlide.previousElementSibling);
      }
    },
    this
  );

  nextButton.addEventListener(
    'click',
    e => {
      shouldAutoplay = false;
      handleAutoplay();
      const currentSlide = track.querySelector('.current-slide');
      const nextSlide = currentSlide.nextElementSibling;
      const nextIndex = slides.findIndex(slide => slide === nextSlide);

      if (nextIndex < 0) {
        moveToSlide(track, currentSlide, slides[0]);
      } else {
        moveToSlide(track, currentSlide, currentSlide.nextElementSibling);
      }
    },
    this
  );

  handleAutoplay();
};

document.addEventListener('DOMContentLoaded', () => {
  const slides = document.getElementsByClassName('carousel__image');
  if(slides.length > 1) {
    initSlider();
  }
});
